import { Box, Button, Grid } from "@material-ui/core"
import { useState } from "react"
import { TextFieldSaurus } from "views/components/controles/inputs"
import { ProcurarIcon } from "views/components/icons"
import { useStyles } from "./accordion-destinatarios-filtros-styles"

export type TAccordionDestinatariosFiltrosProps = {
    setGenerico: (value: string) => void
}

export const AccordionDestinatariosFiltros = (props: TAccordionDestinatariosFiltrosProps) => {
    const [valueGenerico, setValueGenerico] = useState("")
    const classes = useStyles()

    const handleSubmit = () => {
        props.setGenerico(valueGenerico)
    }

    return (
        <Box component="form" width="100%" onSubmit={e => {
            e.preventDefault()
            handleSubmit()
        }}>
            <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                    <Box display="flex" alignItems="center" gridGap={8}>
                        <TextFieldSaurus
                            label="Genérico"
                            placeholder="Pesquise o gerente, cliente ou resposta..."
                            onChange={e => setValueGenerico(e.target.value)}
                            allowSubmit
                        />
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            size="large"
                            className={classes.btn}
                        >
                            <ProcurarIcon tipo="BUTTON_PRIMARY" />
                            Filtrar
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}